import { Injectable } from "@angular/core";
import { KeystoneHttpClient } from "../../keystone-http";
import { Observable, ReplaySubject } from "rxjs";
import { User } from "../core/data/user/user.model";
import { HttpHeaders } from "@angular/common/http";
import {
  FileTransfer,
  FileUploadOptions,
  FileTransferObject,
} from "@ionic-native/file-transfer";
import { FileUploader } from "ng2-file-upload/ng2-file-upload";

@Injectable()
export class UserHttpService {
  constructor(
    private authHttp: KeystoneHttpClient,
    private transfer: FileTransfer
  ) {}

  list(filters: any = {}): Observable<User[]> {
    return this.authHttp
      .get("users", { params: { ...filters } })
      .map((response) => response.users) as Observable<User[]>;
  }

  getForce(authenticatedUser): Observable<User> {
    return this.authHttp
      .get(
        `login-for-user-payment?uid=${authenticatedUser.id}&token=${authenticatedUser.token}`,
        {},
        false
      )
      .map((res) => res);
  }

  get(id): Observable<User> {
    return this.authHttp.get(`users/${id}`).map((res) => res.user);
  }

  update(id: any, userFileds: any): Observable<User> {
    return this.authHttp.put(`users/${id}`, userFileds).map((res) => res.user);
  }

  /**
   * Get list users of current group
   */
  getPartecipant(id: string) {
    return this.authHttp
      .get(`user-groups`, {
        params: {
          "filter[group]": id,
        },
      })
      .map((res) => res["user-groups"]);
  }

  /**
  * Delete single user-groups
  // */

  deleteUserGroup(id: string) {
    return this.authHttp
      .delete(`user-groups/${id}`)
      .map((res) => res["user-groups"]);
  }

  getUserGroupByUser(id: string) {
    return this.authHttp
      .get(`user-groups`, {
        params: {
          "qry-user[]": id,
        },
      })
      .map((res) => res["user-groups"]);
  }

  /**
   * Get group list with name and user associated of current user
   */
  getUsersGroups() {
    return this.authHttp.get(`user-groups-extended`).map((res) => res);
  }

  updatePassword(id, oldPass, newPass) {
    return this.authHttp
      .post(`update-password`, {
        user: id,
        password: newPass,
        oldPassword: oldPass,
      })
      .catch((e) => {
        return Observable.empty();
      });
  }

  uploadAvatar(image: any): Observable<any> {
    if (image) {
      const fto: FileTransferObject = this.transfer.create();
      let res: ReplaySubject<any> = new ReplaySubject(1);
      this.authHttp
        .retrieveHeaders()
        .catch((error) => {
          console.error(error);
          return Observable.of(error);
        })
        .subscribe(async ([token, uid, tokenExpiration, refreshToken]) => {
          let headers = new HttpHeaders();
          headers.append("enctype", "multipart/form-data");
          headers = headers.append("token", token);
          headers = headers.append("uid", uid);
          let options: FileUploadOptions = {
            fileKey: "avatar",
            fileName: image.name,
            headers: {
              token,
              uid,
              enctype: "multipart/form-data",
            },
            httpMethod: "PUT",
          };
          try {
            const data = await fto.upload(
              image.path,
              `${this.authHttp.baseUrl}/users/${uid}`,
              options
            );
            res.next(data);
          } catch (e) {
            console.error(e);
          }
        });
      return res;
    }
  }

  uploadFile(formData: any, uid): Observable<any> {
    if (formData) {
      //return this.authHttp.put(`users/${uid}`, formData)
      let uploader = new FileUploader({
        url: `${this.authHttp.baseUrl}/users/${uid}`,
        itemAlias: "avatar",
        autoUpload: true,
      });

      uploader.onCompleteItem = (file, response) => {
        console.info(file);
        if (response) {
          //this.attivazione.idCard2 = res.idCard2;
        }
      };
    }
    return Observable.of(null);
  }

  //   postFile(fileToUpload: File): Observable<boolean> {
  //     const endpoint = 'your-destination-url';
  //     const formData: FormData = new FormData();
  //     formData.append('fileKey', fileToUpload, fileToUpload.name);
  //     return this.httpClient
  //       .post(endpoint, formData, { headers: yourHeadersConfig })
  //       .map(() => { return true; })
  //       .catch((e) => this.handleError(e));
  // }

  logout(user) {
    if (!user) {
      return null;
    }
    return this.authHttp
      .post("logout", {
        uid: user._id,
      })
      .map((res) => res);
  }
}



// WEBPACK FOOTER //
// ./src/app/user/user-http.service.ts